import { Type } from "@sinclair/typebox";
export const UserIdSchema = Type.String({
    pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$",
});
export const DateTimeSchema = Type.String({
    pattern: "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(?:\\.\\d{3})?Z$",
});
export const EmailSchema = Type.String({
    minLength: 3,
    maxLength: 254,
    pattern: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
});
export const EmailInputSchema = Type.String({
    minLength: 3,
    maxLength: 270,
    pattern: "^\\s*[^\\s@]+@[^\\s@]+\\.[^\\s@]+\\s*$",
});
export const PasswordSchema = Type.String({
    minLength: 8,
    maxLength: 128,
    pattern: "[0-9]",
});
export const UnitSystemSchema = Type.Union([Type.Literal("metric"), Type.Literal("imperial")]);
export const AuthUserSchema = Type.Object({
    id: UserIdSchema,
    email: EmailSchema,
    name: Type.String({ minLength: 1, maxLength: 120 }),
    mustChangePassword: Type.Boolean(),
    unitSystemOverride: Type.Union([UnitSystemSchema, Type.Null()]),
}, { additionalProperties: false });
export const AuthSessionResponseSchema = Type.Object({
    user: AuthUserSchema,
}, { additionalProperties: false });
export const LogoutResponseSchema = Type.Object({ success: Type.Literal(true) }, { additionalProperties: false });
export const MagicLinkRequestSchema = Type.Object({ email: EmailInputSchema }, { additionalProperties: false });
export const MagicLinkVerifyRequestSchema = Type.Object({ token: Type.String({ pattern: "^[A-Za-z0-9_-]{43}$" }) }, { additionalProperties: false });
export const OnboardingRequestSchema = Type.Object({
    name: Type.String({ minLength: 1, maxLength: 120 }),
    orgName: Type.String({ minLength: 1, maxLength: 160 }),
    country: Type.String({ minLength: 2, maxLength: 80 }),
    unitSystem: UnitSystemSchema,
}, { additionalProperties: false });
//# sourceMappingURL=auth.js.map